import React, {useRef, useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import SubCard from "../../../../ui-component/cards/SubCard";
import SmartWatchListTable from "./components/SmartWatchListTable";
import { SWL_NOTIFY, sortSwlNegTs } from "store/actions";
import {
  createChart,
  createPriceLine,
  CrosshairMode,
} from "lightweight-charts";
import { withStyles, useTheme } from "@material-ui/styles";
import colors from 'assets/scss/_themes-vars.module.scss';


// vel_positive: {"bar_vol":4500,"end_ref":2.73951,"icon":"images/logo_MANAUSD.png","logo":"logo_MANAUSD","percent":1.1650836792271744,"rate_of_change_one":2322.4479078520258,"rate_of_change_two":4073.783039223284,"since":205,"start_ref":2.70796,"symbol":"MANA/USD","ts":1636504838,"velocity_one":0.0005016619211514334,"velocity_two":0.028599551522736754},

// "swl_positive":{"bar_count":3,"bar_vol":4500,"delta":0.03155000000000019,"end_ref":2.73951,"icon":"images/logo_MANAUSD.png","logo":"logo_MANAUSD","ohlc":{"close":0,"epoch":0,"high":0,"low":0,"open":0},"percent":1.1650836792271744,"side":"buy","since":205,"start_ref":2.70796,"symbol":"MANA/USD","ts":1636504838},"

const swl_list = require("assets/json/SWL.json");

let swl_fires = [];
let swl_count = 0;

const SwlNegative = () => {
  const dispatch = useDispatch();
  let [swlCount, setSwlCount] = useState(0);
  let [swlLength, setSwlLength] = useState(600);

  const theme = useTheme();
  const bgcolor = (theme.palette.mode === 'dark') ? '#00070f' : 'white';
    const cornsilk = (theme.palette.mode === 'dark') ? colors.cornsilkLightTakyon : colors.cornsilkDarkTakyon;

  let positives = 0;
  let negatives = 0;
  let breakoutSentiment = 0;

    /**************************
    Object.keys(swl_list).forEach( (key) => {
        swl_fires = [...swl_list[key], swl_fires];
    });
    // TMD console.log( swl_fires.length);
    // setSwlLength( swl_fires.length);

  useEffect(() => {
    let balanceTimer = setInterval(() => {
      // TMD console.log("SAMEER: SWL Negative --------------> " + swlCount + ", " + swlLength);
      // TMD console.log( swl_fires[swlCount % swlLength]);
      let payload = {'data': {'data': swl_fires[swlCount % swlLength].data}};
      dispatch({ type: SWL_NOTIFY, payload: payload});
      setSwlCount( swlCount++);
    }, 1000);
  }, []);
  *************************/

  const listSwlNegative = useSelector((state) => {
    let items = [];

    if ( state.coins === undefined || state.coins.kraken_asset_pairs === undefined)
    {
         return items;
    }

    state.coins.kraken_asset_pairs.forEach((item) => {
        
        if (item !== undefined  && item.swl_single !== undefined && (item.swl_single.status !== 2))
        {
            if ( item.position !== undefined)
            {
                item.swl_single.avg = item.position.remaining_avg_price.toFixed(3);
            }
            item.epoch_start = item.swl_single.epoch_start;
            item.ts = item.swl_single.ts;
            item.since = item.swl_single.since;
            item.percent = item.swl_single.percent;
            if ( item.percent > 0.0)
            {
                ++positives;
            }
            else
            {
                ++negatives;
            }
            items.push(item);
        }

    });

    return items;
  });

  const listSwlDouble = useSelector((state) => {
    let items = [];

    if ( state.coins === undefined || state.coins.kraken_asset_pairs === undefined)
    {
         return items;
    }
    state.coins.kraken_asset_pairs.forEach((item) => {
        if (item !== undefined  && item.swl_double !== undefined && (item.swl_double.status !== 2))
        {
            if ( item.position !== undefined)
            {
                item.swl_double.avg = item.position.remaining_avg_price.toFixed(3);
            }
            item.epoch_start = item.swl_double.epoch_start;
            item.ts = item.swl_double.ts;
            item.since = item.swl_double.since;
            item.percent = item.swl_double.percent;
            items.push(item);
        }
    });
    return items;
  });

  if ( (positives + negatives) > 0)
  {
    breakoutSentiment = ((positives - negatives) * 100) / (positives + negatives);
  }
  // TMD console.log('BREAKOUT_SENTIMENT------> ' + breakoutSentiment + ', ' + positives + ', ' + negatives + ', ' + listSwlNegative.length);

  /*
  const historySwlNegative = useSelector((state) => {
    let items = [];

    if ( state.coins === undefined || state.coins.kraken_asset_pairs === undefined)
    {
         return items;
    }

    const now = Date.now() /1000;
    state.coins.kraken_asset_pairs.forEach((item) => {
        
        if (item !== undefined && item.swl_single !== undefined && (item.swl_single.status === 2) && ((now - item.swl_single.ts) < 300) )
        {
            if ( item.position !== undefined)
            {
                item.swl_single.avg = item.position.remaining_avg_price.toFixed(3);
                item.epoch_start = item.swl_single.epoch_start;
            }
            items.push(item);
        }

    });
    return items;
  });

    const cdata_coin = useSelector((state) => {
        return state.coins.cdata_coin.get("ETH/USD");
    });
  */

  const handleSortBuyCoin = () => dispatch(sortSwlNegTs("ts"));
  const handleSortBuyPercent = () => dispatch(sortSwlNegTs("percent"));

  return (
    <>
        <SmartWatchListTable type="SWL-2-day-Hi" items={listSwlNegative} positives={positives} negatives={negatives} sentiment={breakoutSentiment} inputRef={null}/>
        <Grid spacing={1} padding={1} />
        <SmartWatchListTable type="SWL-Backlog" items={listSwlNegative} positives={positives} negatives={negatives} sentiment={breakoutSentiment} inputRef={null}/>
        <Grid spacing={1} padding={1} />
        <SmartWatchListTable type="SWL-Medium" items={listSwlDouble} positives={positives} negatives={negatives} sentiment={breakoutSentiment} inputRef={null}/>
    </>
  );
};

export default React.memo(SwlNegative);
